module.exports = __webpack_public_path__ + "media/images/pages/facebook_white-4487c286f2496d66995e29d4df3276d1.png";